import React from "react";
import { withStyles, makeStyles } from "@material-ui/core";
import {
  Paper,
  Table,
  TableBody,
  TableHead,
  TableRow,TableCell
} from "@material-ui/core";
const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.background.default,
    },
  },
}))(TableRow);

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing(3),
    overflowX: "auto",
  },
  table: {
    minWidth: 700,
  },
}));

export default function LiteracyTable(props) {
  const classes = useStyles();

  return (
    <Paper className={classes.root}>
      <Table className={classes.table}>
        <TableHead>
          <TableRow>
            <StyledTableCell>School Year</StyledTableCell>
            <StyledTableCell>1st MP</StyledTableCell>
            <StyledTableCell>2nd MP</StyledTableCell>
            <StyledTableCell>3rd MP</StyledTableCell>
            <StyledTableCell>4th MP</StyledTableCell>
            <StyledTableCell>Tutoring Session</StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props.tableData && props.tableData.length ? (
            props.tableData.map((row, i) => (
              <StyledTableRow key={i}>
                <StyledTableCell component="th" scope="row">
                  {row.schoolYear ? row.schoolYear : "-"}
                </StyledTableCell>
                <StyledTableCell>{row.mp1 ? row.mp1 : "-"}</StyledTableCell>
                <StyledTableCell>{row.mp2 ? row.mp2 : "-"}</StyledTableCell>
                <StyledTableCell>{row.mp3 ? row.mp3 : "-"}</StyledTableCell>
                <StyledTableCell>{row.mp4 ? row.mp4 : "-"}</StyledTableCell>
                <StyledTableCell>
                  {row.tutoring_sessions ? row.tutoring_sessions : "-"}
                </StyledTableCell>
              </StyledTableRow>
            ))
          ) : (
            <p>No Data</p>
          )}
        </TableBody>
      </Table>
    </Paper>
  );
}
